Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hexToRGBA = require('./utils/hexToRGBA');

var _hexToRGBA2 = _interopRequireDefault(_hexToRGBA);

var _colors = require('./utils/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var core = _colors2['default'].core,
    black = _colors2['default'].black,
    white = _colors2['default'].white,
    clear = _colors2['default'].clear,
    buttonColors = _colors2['default'].buttons;

// fun fact: the colors in the `darker` object are somewhere in between core and dark in
// terms of lightness. TODO(maja): find a better name.

var darker = {
  rausch: '#d43242',
  arches: '#d93900'
};

var dark = {
  babu: '#006C70',
  rausch: '#950004',
  arches: '#8A2400'
};

var accent = {
  bgGray: '#F2F2F2',
  lightGray: '#D8D8D8',
  darkGray: '#2B2B2B',
  hrGray: '#DBDBDB',
  beach: '#FFB400',
  blue: '#41C6BC',
  babuDark: (0, _hexToRGBA2['default'])(dark.babu, 0.15),
  babuLight: '#CCEEEB',
  olinda: '#f7f3ea',
  online: '#5CDC97'
};

var status = {
  danger: core.arches,
  info: core.babu,
  warning: accent.beach,
  online: accent.online
};

var buttons = Object.assign({}, buttonColors, {

  // Other button colors
  floatingBackground: white,
  floatingDivider: core.foggy,

  luxuryButtonBorder: (0, _hexToRGBA2['default'])(black, 0.5),
  luxuryButtonBorderInverse: (0, _hexToRGBA2['default'])(white, 0.5)
});

var autocomplete = {
  resultsBackground: white,
  resultsBorder: accent.hrGray,
  resultActiveBackground: accent.babuLight,
  resultIcon: core.foggy,
  resultIconInverse: white
};

var mapPriceMarker = {
  defaultBackground: white,
  defaultBorder: (0, _hexToRGBA2['default'])(black, 0.2),
  defaultText: '#222222',
  shadow: (0, _hexToRGBA2['default'])(black, 0.15),
  activeDefaultBackground: core.babu,
  activeDefaultBorder: core.babu,
  activeDefaultText: white,
  activeSelectBackground: core.hackberry,
  activeSelectBorder: core.hackberry,
  activeSelectText: white,
  viewedText: core.foggy
};

exports['default'] = {
  hexToRGBA: _hexToRGBA2['default'],
  opacity: _hexToRGBA2['default'], // deprecated: use hexToRGBA instead
  core: core,
  dark: dark,
  darker: darker,
  accent: accent,
  status: status,
  white: white,
  black: black,
  focus: core.babu,
  clear: clear,
  buttons: buttons,
  imageBackground: '#bbbbbb',
  textDark: core.hof,
  textLight: white,
  textInput: core.babu,
  textLink: core.babu,
  textLinkActive: dark.babu,
  textLinkHover: core.babu,
  textLinkInverseHover: white,
  textLinkInverseActive: dark.babu,
  textLinkNavigation: core.hof,
  textLinkNavigationHover: core.hof,
  textMuted: '#767676',
  textDisabled: accent.hrGray,
  textMutedLarge: '#848484',
  textPlaceholder: accent.hrGray,
  backgroundLight: white,
  backgroundLightHighlightedOrSelected: accent.hrGray,
  backgroundDark: core.foggy,
  placeholder: core.foggy,
  divider: accent.hrGray,
  cursor: core.babu,
  heroBackground: core.rausch,
  sheetBackground: core.babu,
  sheetBackgroundInvalid: core.arches,
  sheetContentColor: white,
  sheetInactiveContentColor: core.babu,
  loaderColorLight: white,
  loaderColorDark: core.babu,
  loaderColorError: accent.beach,
  buttonBarButton: core.babu,
  buttonBarButtonTapped: '#00998C',
  buttonBarText: white,
  backgroundListingTags: 'rgba(43, 43, 43, 0.75)',
  rowPlaceholderText: '#878787',
  rowUnderlay: '#dedede',
  panelBorder: '#e4e4e4',
  mapRefreshLoaderBackground: core.babu,
  mapRefreshShadow: (0, _hexToRGBA2['default'])(core.hof, 0.3),
  microSectionHeaderText: core.foggy,
  signpostShadow: (0, _hexToRGBA2['default'])(core.hof, 0.3),
  mapSignpost: core.hof,
  regionBorder: core.babu,
  regionBackground: (0, _hexToRGBA2['default'])(core.babu, 0.3),
  toolbarDark: core.babu,
  starBlankColor: accent.lightGray,
  starHighlightColor: accent.beach,
  starBabuHighlightColor: core.babu,
  starSelectHighlightColor: core.hackberry,
  inputBackground: white,
  inputBorder: accent.hrGray,
  inputFocusedBorder: core.babu,
  inputFocusedUnderlineBorder: core.babu,
  inputInvalidBorder: core.arches,
  inputInvalidBackground: '#FFF8F6',
  inputErrorMessage: darker.arches,
  inputPrefixSelectBackground: white,
  inputPrefixSelectBorder: accent.hrGray,

  checked: core.babu,
  checkBoxShadow: accent.babuLight,
  checkedDisabled: accent.bgGray,
  inputDisabled: accent.bgGray,
  selectDisabled: accent.bgGray,

  autocomplete: autocomplete,
  carousel: {
    overlay: (0, _hexToRGBA2['default'])(black, 0.3)
  },
  listingCard: {
    indicator: (0, _hexToRGBA2['default'])(accent.darkGray, 0.75)
  },
  mapPriceMarker: mapPriceMarker,
  modal: {
    overlay: (0, _hexToRGBA2['default'])(black, 0.75),
    whiteOverlay: (0, _hexToRGBA2['default'])(white, 0.8),
    background: white
  },
  toggleButton: {
    background: white,
    backgroundSelected: core.hof
  },
  pageIndicatorDots: {
    background: (0, _hexToRGBA2['default'])(core.hof, 0.8),
    backgroundSelected: core.hof,

    backgroundLight: (0, _hexToRGBA2['default'])('#FFFFFF', 0.8),
    backgroundSelectedLight: white
  },

  loaderDots: {
    'default': core.babu,
    light: white,
    dark: core.hof
  },
  printOverrides: {
    textMuted: core.hof,
    textMutedLarge: core.hof
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/color.js
// module id = 72
// module chunks = 168707334958949